module.exports = __webpack_public_path__ + "static/img/gold_bar_bg.a0052d4e.png";